import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, Loader, NoItemsYet } from 'components';
import { FindLoad, Images, sortListByKey, useModal } from 'utils';
import { systemActions } from 'store';
import { systemItemStyles } from './styles';
import { CreateEditJobTitle } from './modals/createEditJobTitle';
import { jobTitleNotYet } from './constants';

const ACTION_TYPE = 'GET_JOBS';

export const JobTitles = ({ }) => {
    const globalJobs = useSelector((state) => state.system.jobs);
    const classes = systemItemStyles();
    const dispatch = useDispatch();
    const getLoader = FindLoad(ACTION_TYPE);
    const { open } = useModal();
    const jobsList = sortListByKey(globalJobs, 'name');

    useEffect(() => {
        dispatch(systemActions.getJobs());
    }, []);

    if (getLoader?.length) {
        return <Loader />;
    }

    return (
        <Fragment>
            <div className="header-action-btn">
                <AddCircleBlue text={'Add Job Title'} handleClick={() => open(<CreateEditJobTitle />)} />
            </div>
            {jobsList?.length ? (
                <div className={classes.credentialTable}>
                    {jobsList?.map((jobItem, index) => {
                        return (
                            <div className={classes.item} key={index}>
                                <p>
                                    <span>{jobItem?.name}</span>
                                </p>
                                <div className={classes.icons}>
                                    <img src={Images.edit} alt="edit" onClick={() => open(<CreateEditJobTitle info={jobItem} />)} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <NoItemsYet height={'300px'} text={jobTitleNotYet.title} subTitle={jobTitleNotYet.subTitle} image={jobTitleNotYet.image} />
            )}
        </Fragment>
    );
};
